import { render } from "./InviteClientListEntryAndModal.vue?vue&type=template&id=27c18fa4&scoped=true"
import script from "./InviteClientListEntryAndModal.vue?vue&type=script&lang=js"
export * from "./InviteClientListEntryAndModal.vue?vue&type=script&lang=js"

import "./InviteClientListEntryAndModal.vue?vue&type=style&index=0&id=27c18fa4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c18fa4"]])

export default __exports__